import { useMemo } from "react";
import { useEffect } from "react";
import type { ReactNode } from "react";

const SITE_URL = "https://workoutpro0.github.io";
const DEFAULT_DESC =
  "在43423漫画网免费阅读《健身教练》漫画全集，在线浏览全集中文故事，无需付费即可享受完整章节和高清画面。";
const DEFAULT_KEYWORDS = "健身教练,漫画,免费阅读,漫画全集,43423漫画网";
const DEFAULT_IMAGE =
  "https://readdy.ai/api/search-image?query=Energetic%20manga%20style%20illustration%20of%20a%20fit%20personal%20trainer%20coaching%20happy%20students%20doing%20dumbbell%20workouts%20in%20a%20bright%20modern%20gym%20with%20warm%20orange%20and%20red%20color%20palette%2C%20dynamic%20bold%20anime%20art%2C%20dramatic%20composition%20with%20open%20space%20in%20the%20center%20for%20text%20overlay%2C%20high%20detail%2C%20cinematic%20warm%20lighting&width=1600&height=900&seq=hero-fitness-banner&orientation=landscape";

interface SeoHeadProps {
  title: string;
  description?: string;
  keywords?: string;
  path?: string;
  type?: "website" | "article" | "book";
  image?: string;
  jsonLd?: object[];
  children?: ReactNode;
}

function setMeta(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setProperty(prop: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SeoHead({
  title,
  description,
  keywords,
  path = "/",
  type = "website",
  image,
  jsonLd,
  children,
}: SeoHeadProps) {
  const jsonLdKey = useMemo(() => JSON.stringify(jsonLd ?? []), [jsonLd]);

  useEffect(() => {
    const desc = description || DEFAULT_DESC;
    document.title = title;
    setMeta("description", desc);
    setMeta("keywords", keywords || DEFAULT_KEYWORDS);
    setMeta("author", "43423漫画网");
    setMeta("robots", "index, follow");
    setMeta("theme-color", "#f25c05");

    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) canonical.href = `${SITE_URL}${path}`;

    setProperty("og:title", title);
    setProperty("og:description", desc);
    setProperty("og:type", type);
    setProperty("og:url", `${SITE_URL}${path}`);
    setProperty("og:image", image || DEFAULT_IMAGE);
    setProperty("og:locale", "zh_CN");
    setProperty("twitter:card", "summary_large_image");
    setProperty("twitter:title", title);
    setProperty("twitter:description", desc);
    setProperty("twitter:image", image || DEFAULT_IMAGE);

    let script = document.getElementById("dynamic-jsonld") as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = "dynamic-jsonld";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    let payload: string = "";
    try {
      const parsed = JSON.parse(jsonLdKey) as object[];
      if (parsed && parsed.length) {
        payload = JSON.stringify(
          parsed.length === 1 ? parsed[0] : { "@context": "https://schema.org", "@graph": parsed },
        );
      }
    } catch {
      payload = "";
    }
    script.textContent = payload;
  }, [title, description, keywords, path, type, image, jsonLdKey]);

  return <>{children}</>;
}